import type { FaireProductEntity } from "../../entity_types/product";

export const p_ua6rnzuxn6: FaireProductEntity = {
  token: "p_ua6rnzuxn6",
  type: "product",
  name: "Blue Sunshine Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6206eef620b7fa5ed4ae344a22da0a9deb49da4a34b4bcfc1771c4fa7c339767.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dea8429fefa51f01e3a0f99e850ad71707717250175660ec86d7d29d0f549178.jpeg",
    "https://cdn.faire.com/fastly/abdb45024baeeadbb64c977e1b5d414df87dfba3bbd200fe034c4ce0909aeb69.jpeg",
    "https://cdn.faire.com/fastly/67243a1bf70c4655780ce7975c66c710247a3e67934cd0c50f83afbe227c321e.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:32.404Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
